import { InfrastructureBase } from '@src/slide/infrastructure/entry/base/infrastructure-base';
import { AppEntryType } from '@src/slide/infrastructure/entry/base/infrastructure-base.interface';
import { initReport } from '@src/slide/infrastructure/module/dependent/report/report-initializator';

export class InfrastructurePc extends InfrastructureBase {
    public constructor() {
        super();
    }

    public getEntryType(): AppEntryType {
        return AppEntryType.PC_EDIT;
    }

    protected initReport(): void {
        initReport(this.getEntryType());
    }
}
